import { get, writable } from "svelte/store";
import PopupType from "./PopupType";
import AlertTypeDescriptions from "../../Alerts/AlertTypeDescriptions";
import AlertType from "../../Alerts/AlertType";

// TODO: rename this Store.js to keep convention
const PopupStoreDefaultData = {
	type: PopupType.VESSEL,
	data: {
		[PopupType.VESSEL]: {
			vessel: null
		},
		all: {
			imo: 0,
			mmsi: 0,
			name: "",
			coordinates: [],
			speed: 0,
			timestamp: 0,
			extraData: {}
		},
		custom: {}
	},
	visible: false
};

const PopupStore = writable(PopupStoreDefaultData);

PopupStore.helpers = {};
// PopupStore.helpers.generateKeyValueList = (obj) => {
// 	let contents = "";
// 	const keys = Object.keys(obj);
// 	for (const key in keys) {
// 		const keyName = keys[key].substr(0, 1).toUpperCase() + keys[key].substr(1);
// 		const keyValue = obj[keys[key]];
// 		contents += `<strong>${keyName}:</strong> ${keyValue}<br/>`;
// 	}
// 	return contents;
// };
PopupStore.helpers.generateKeyValueList = (obj, params = { asTable: false, isAlertTypes: false }) => {
	// console.log(params);
	let contents = params.asTable ? "<table class='key-value-table'>" : "";
	const keys = Object.keys(obj);
	if (!keys.length) return "";
	for (const key in keys) {
		const keyName = keys[key].substr(0, 1).toUpperCase() + keys[key].substr(1);
		const keyValue = obj[keys[key]];

		if (params.asTable) {
			let title = keyName;
			if (params.isAlertTypes) {
				if (AlertTypeDescriptions.hasOwnProperty(AlertType[keyName])) { // eslint-disable-line
					title = AlertTypeDescriptions[AlertType[keyName]].split(" ").join("_");
				}
				else {
					console.log(AlertType[keyName], AlertTypeDescriptions);
				}
			}
			contents +=
				`<tr title=${title}>
					<td>${keyName}</td>
					<td>${keyValue}</td>
				</tr>`;
		}
		else {
			contents += `<strong>${keyName}:</strong> ${keyValue}<br/>`;
		}
	}
	if (params.asTable) contents += "</table>";
	return contents;
};

PopupStore.actions = {};
PopupStore.actions.set = (type, vessel, imo, mmsi, name, coordinates, speed, courseHeading, timestamp, visible, extraData = {}) => {
	const newCoords = (coordinates !== null) ? coordinates : get(PopupStore).data.all.coordinates;
	PopupStore.set({
		type: type,
		data: {
			[PopupType.VESSEL]: {
				vessel: vessel
			},
			all: {
				imo: imo,
				mmsi: mmsi,
				name: name,
				coordinates: newCoords,
				speed: speed,
				courseHeading: courseHeading,
				timestamp: timestamp,
				extraData: extraData
			}
		},
		visible: visible
	});
};
PopupStore.actions.custom = (properties, coordinates, visible) => {
	const newCoords = (coordinates !== null) ? coordinates : get(PopupStore).data.all.coordinates;
	PopupStore.set({
		type: PopupType.CUSTOM,
		data: {
			custom: properties,
			all: {
				coordinates: newCoords
			}
		},
		visible: visible
	});
};
PopupStore.actions.customHtml = (html, width, coordinates, visible) => {
	const newCoords = (coordinates !== null) ? coordinates : get(PopupStore).data.all.coordinates;
	PopupStore.set({
		type: PopupType.CUSTOM_HTML,
		data: {
			customHtml: {
				html: html,
				width: width
			},
			all: {
				coordinates: newCoords
			}
		},
		visible: visible
	});
};

export default PopupStore;
